import { UploadImage } from "@/libs/Api/Uploader";
import Helper from "@/libs/Helper";

export default class UploadAdapter {
  constructor(loader, ctx) {
    // The file loader instance to use during the upload.
    this.loader = loader;
    this.context = ctx;
  }

  async sendCreateFileRequest(formData) {
    let result = "";
    try {
      this.context.loading();
      let _this = this;
      let uploadImage = new UploadImage(_this);
      uploadImage.setFormData(formData);
      await uploadImage.sendFormData((response) => {
        if (response) {
          result = response.data.url;
        }
      });
    } catch (error) {
      console.error(error);
    } finally {
      this.context.loaded();
    }
    return result;
  }

  // Starts the upload process.
  convertBase64ToFile(base64String, filename = "test") {
    // Extract the base64 data and mime type
    const [header, data] = base64String.split(",");
    const mimeType = header.match(/:(.*?);/)[1];

    // Decode the base64 string
    const byteString = atob(data);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // Create a Blob from the ArrayBuffer
    const blob = new Blob([ab], { type: mimeType });

    // Create a File from the Blob
    const file = new File([blob], `${filename}.${mimeType.split("/")[1]}`, {
      type: mimeType,
    });

    return file;
  }

  async upload() {
    return new Promise((resolve, reject) => {
      const myFormData = new FormData();
      const reader = new window.FileReader();
      reader.addEventListener("load", async () => {
        const imageFile = this.convertBase64ToFile(reader.result);
        myFormData.append("ImageFile", imageFile);
        myFormData.append("FileType", 0);
        myFormData.append("Title", "Notification");
        myFormData.append("Alt", "Notification");
        myFormData.append("Description", "Ferman Notifications");
        let result = await this.sendCreateFileRequest(myFormData);
        resolve({ default: result });
      });
      reader.addEventListener("error", (err) => {
        reject(err);
      });

      reader.addEventListener("abort", () => {
        reject();
      });

      this.loader.file.then((file) => {
        reader.readAsDataURL(file);
      });
    });
  }

  // Aborts the upload process.
  abort() {
    //
  }
}
